import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  CreateButton,
  Datagrid,
  EditButton,
  List,
  ReferenceField,
  ShowButton,
  SimpleList,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { administrationRequests } from "api/administrationApi";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import DoctoralDateField from "../Partials/DoctoralDateField";

const campaignFilters = [
  <TextInput
    label="Име на български език"
    source="nameBg"
    style={{ width: 400 }}
    alwaysOn
  />,
];

const ListDoctoralCampaigns = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return <TopToolbar>{hasCreate && <CreateButton />}</TopToolbar>;
  };

  return (
    <List
      title="Докторантски кампании"
      filters={campaignFilters}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateDoctoralCampaigns)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Факултет",
                    value: (
                      <ReferenceField
                        source="structuralUnitId"
                        reference={administrationRequests.getStructuralUnitsSelect()}
                        link={false}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "От",
                    value: (
                      <>
                        <DoctoralDateField source="dateFrom" /> — <DoctoralDateField source="dateTo" />
                      </>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateDoctoralCampaigns}>
                <EditButton label="" />
              </SecuredComponent>
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid bulkActionButtons={false} rowClick={false}>
          <TextField source="nameBg" label="Име на български език" sortable={false} />
          <TextField source="nameEn" label="Име на английски език" sortable={false} />
          <ReferenceField
            label="Факултет"
            source="structuralUnitId"
            reference={administrationRequests.getStructuralUnitsSelect()}
            link={false}
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <DoctoralDateField source="dateFrom" label="От дата" sortable={false} />
          <DoctoralDateField source="dateTo" label="До дата" sortable={false} />
          <SecuredComponent permission={permissions.canUpdateDoctoralCampaigns}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListDoctoralCampaigns;
